interface Props extends React.HTMLAttributes<HTMLDivElement> {
  children: React.ReactNode;
  width?: string;
  bg?: string;
  p?: string;
  mb?: string;
  borderRadius?: string;
  border?: string;
  overflowX?: string;
  textDecoration?: string;
  onClick?: () => void;
}

const Hover = ({
  children,
  width,
  bg,
  p,
  mb,
  borderRadius,
  border,
  overflowX,
  textDecoration,
  style,
  ...props
}: Props) => {
  return (
    <div
      className="inline-block hover:cursor-pointer"
      style={{
        width,
        background: bg ? `var(--${bg})` : undefined,
        padding: p,
        marginBottom: mb,
        borderRadius,
        border,
        overflowX: overflowX as any,
        textDecoration,
        ...style,
      }}
      {...props}
    >
      {children}
    </div>
  );
};

export default Hover;
